import * as React from "react";
import { connect } from "react-redux";
import Iframe from 'react-iframe';
import { withRouter } from 'react-router';
import { Nav, NavItem } from 'reactstrap';
import { Link } from "react-router-dom";
import Cookies from "cookies-js";
import { getDomain } from "../../helpers/Tools";
//import ReactIframeResizer from "react-iframe-resizer-super";
import ReactIframeResizer from "../common/iFrameResizerComponent";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartContainer from "./MyChartContainer";

class VideoVisitBHConsentForm extends React.Component {
    constructor(props) {
        super(props);
        this.serverData = this.props.serverData;
        this.state = {};
    }

    componentDidMount() {
        logUI("MBHWeb.UI.VideoVisitBHConsent.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        //debugger;
        var mode = 'showform&formname=VideoVisitBHConsent';
        var preurl = this.props.serverData.myChartDataTileUrl;
        var url = `${preurl}${mode}`;
        const iframeResizerOptions = { checkOrigin: false, minHeight: 1400, scrolling: true, heightCalculationMethod: 'bodyScroll' };
        const iframeResizerStyle = { width: '100%' };

        return <MyChartContainer id={"mychartVideoVisitBHConsent"} mode="showform" form="VideoVisitBHConsent" title="Behavioral Health Video Visit Consent" iframeResizerOptions={iframeResizerOptions} src={url} style={iframeResizerStyle} />;
    }
}

const mapStateToProps = (state) => {
    return {
        serverData: state.session.serverData
    };
};

const Tile = connect(
    mapStateToProps
)(VideoVisitBHConsentForm);

export default withRouter(Tile);